import "../css/main.css";
import { toggleHamburger } from "./toggleHamburger";
import { accordion } from "./accordion";
import { tabMenu } from "./tabMenu";
import { initializeViewport } from "./initializeViewport";
import { initBackToTopButton } from "./backToTop";
import { smoothScrollToHash, setupAnchorLinks } from "./smoothScroll";
import { showroomSlider } from "./showroomSlider";
import { topMvSlider } from "./topMvSlider";

document.addEventListener("DOMContentLoaded", () => {
  toggleHamburger("js-hamburger", "js-spmenu", 1024);
  accordion();
  tabMenu();
  initializeViewport();
  initBackToTopButton();
  setupAnchorLinks();
  showroomSlider();
  topMvSlider();
});

window.addEventListener("load", () => {
  smoothScrollToHash();
});
